/* eslint-disable radix */
/* eslint-disable no-shadow */
/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import { ADD_EDIT_CONSTANT, currentDatePlusDaysToEpoch } from 'utils/constants';
import {
  CREATE_USER_SUBSCRIPTION_PLAN,
  UPDATE_USER_SUBSCRIPTION_PLAN,
} from 'pages/SubscriptionPlans/subscriptionPlanGraphQL';
import { vendorPlanValidationSchema } from 'components/Drawers/components/VendorDetailsDrawer/constant';
import ErrorBoundary from 'components/common/ErrorBoundary';
import VendorSubscribeForm from './components/VendorSubscribeForm';
import VendorSubscriberList from './components/VendorSubscriberList';

const VendorSubscribe = ({
  drawerToggle,
  type,
  id,
  currency,
  row,
  refetch,
}) => {
  const [calculateAmount, setCalculateAmount] = useState(null);
  // console.log('row', row);
  const [createUserSubscription] = useMutation(CREATE_USER_SUBSCRIPTION_PLAN, {
    onCompleted: () => {
      // if (createUserSubscription?.status === 204)
      //   toast.error(createUserSubscription?.message);
      // if (createUserSubscription?.status === 200)
      toast.success("User's Subscription Plan created successfully");
      refetch();
      drawerToggle('', ADD_EDIT_CONSTANT.ADD);
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
      drawerToggle('', ADD_EDIT_CONSTANT.ADD);
    },
  });
  const [upgradeUserSubscription] = useMutation(UPDATE_USER_SUBSCRIPTION_PLAN, {
    // eslint-disable-next-line no-shadow
    onCompleted: () => {
      // if (upgradeUserSubscription?.status === 204)
      //   toast.error(upgradeUserSubscription?.message);
      // if (upgradeUserSubscription?.status === 200)
      toast.success("User's Subscription Plan updated successfully");
      refetch();
      drawerToggle('', ADD_EDIT_CONSTANT.ADD);
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
      drawerToggle('', ADD_EDIT_CONSTANT.ADD);
    },
  });
  const handleSubmit = async (values) => {
    try {
      const data = {
        ...values,
        subscriptionPlan: parseInt(values.id),
        // mode_of_payment: values?.mode_of_payment?.id,
        trader: id,
        activationDate: currentDatePlusDaysToEpoch(),
        deactivationDate: currentDatePlusDaysToEpoch(values?.duration),
        couponCode: values?.coupon?.code,
        discountAmount: calculateAmount?.couponAmount,
        sgst: calculateAmount?.sGstAmount,
        cgst: calculateAmount?.cGstAmount,
        igst: calculateAmount?.iGstAmount,
        grandTotal: calculateAmount?.grandTotal,
        subTotal: calculateAmount?.subscriptionAmount,
      };
      delete data.coupon;
      delete data.__typename;
      delete data.subscriptionAmount;
      delete data.price;
      delete data.duration;
      delete data.id;
      delete data.discountedAmount;
      // delete data.couponAmount
      if (type === ADD_EDIT_CONSTANT.EDIT) {
        await upgradeUserSubscription({
          variables: {
            updateInput: { ...data },
            upgradeSubscriptionHistoryInputDTO: {
              oldUserSubscriptionId: parseInt(row?.id),
              newPlanId: parseInt(values.id),
              upgradeDate: currentDatePlusDaysToEpoch(),
              proRataAmount: calculateAmount?.proRataAmount,
              oldPlanId: parseInt(row?.subscriptionPlan?.id),
            },
            platformType: 'ADMIN',
          },
        });
      } else {
        await createUserSubscription({
          variables: { createInput: data, platformType: 'ADMIN' },
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <VendorSubscriberList vendorId={id} currency={currency} />
      <ErrorBoundary>
        <Formik
          initialValues={{
            subscriptionPlan: '',
            duration: '',
            price: '',
            // mode_of_payment: '',
            coupon: '',
            trader: id,
            activationDate: '',
            deactivationDate: '',
            isAutoPayEnabled: false,
            isTrial: false,
            status: 'ACTIVE',
            isExpired: false,
            isDeleted: false,
            discountedAmount: '',
          }}
          enableReinitialize
          validationSchema={vendorPlanValidationSchema}
          onSubmit={handleSubmit}
          children={(props) => {
            return (
              <VendorSubscribeForm
                id={id}
                type={type}
                row={row}
                currency={currency}
                {...props}
                drawerToggle={drawerToggle}
                calculateAmount={calculateAmount}
                setCalculateAmount={setCalculateAmount}
                deactivationDate={
                  row?.deactivationDate ? row?.deactivationDate : null
                }
              />
            );
          }}
        />
      </ErrorBoundary>
    </div>
  );
};

export default VendorSubscribe;
